import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import { loadExcelSpreadsheetTemplates } from '~/api/data/excel-templates/queries';
import { loadCustomForms } from '~/api/data/forms/queries';
import { loadHtmlDocumentTemplates } from '~/api/data/html-templates/queries';
import { loadCustomPreset, loadCustomPresets } from '~/api/data/presets/queries';
import { loadServiceRequests } from '~/api/data/servicing/queries';
import { submitUpdateAgencyUserPreferences } from '~/api/data/users/mutations';
import { loadCurrentUser } from '~/api/data/users/queries';
import { loadWordDocumentTemplates } from '~/api/data/word-templates/queries';
import { PresetRunPage } from '~/pages/presets/presets';
import { HomePage } from '~/pages/home/home';

export const homeRoute: RouteObject = {
  id: 'home',
  path: 'home',
  loader: merge({
    agencyUser: loadCurrentUser,
    serviceRequests: loadServiceRequests,
    htmlDocumentTemplates: loadHtmlDocumentTemplates,
    wordDocumentTemplates: loadWordDocumentTemplates,
    excelSpreadsheetTemplates: loadExcelSpreadsheetTemplates,
    customPresets: loadCustomPresets,
    customForms: loadCustomForms
  }),
  element: <HomePage />,
  children: [
    {
      // Element-less: the Memory settings page submits preference changes
      // here with useFetcher rather than navigating to a page of its own.
      path: 'preferences',
      action: byMethod({ PUT: submitUpdateAgencyUserPreferences })
    },
    {
      path: 'presets/:id',
      loader: merge({
        preset: loadCustomPreset,
        customForms: loadCustomForms,
        htmlDocumentTemplates: loadHtmlDocumentTemplates,
        wordDocumentTemplates: loadWordDocumentTemplates,
        excelSpreadsheetTemplates: loadExcelSpreadsheetTemplates
      }),
      element: <PresetRunPage />
    }
  ]
};
